import { sessionStorageAction } from '@vindr/utils/helpers/storage';
import { ImmerReducer } from 'use-immer';

export type GlobalLayoutAction = { type: 'SET_SPLIT_VIEW'; payload: boolean };

export type GlobalLayoutState = {
  splitView: boolean;
};

export const global_key = 'globalSetting';

export const globalInitialState: GlobalLayoutState = sessionStorageAction.get(global_key, {
  splitView: true,
});

export const globalReducer: ImmerReducer<GlobalLayoutState, GlobalLayoutAction> = (state, action) => {
  switch (action.type) {
    case 'SET_SPLIT_VIEW':
      state.splitView = action.payload;
      break;
    default:
      break;
  }
  sessionStorageAction.set(global_key, state);
};
